
import { Component, Prop, Ref, mixins } from 'nuxt-property-decorator';
import UpgradeMixin from './UpgradeMixin';
import { ActionSpinner } from 'fourwaves-shared/components';

@Component({
  components: {
    ActionSpinner,
  },
})
export default class UpgradeButton extends mixins(UpgradeMixin) {
  @Prop({ type: String, default: 'sm' }) readonly size!: string;
  @Prop({ type: String, default: 'secondary-color' }) readonly hierarchy!: string;
  @Prop({ type: Boolean, default: true }) readonly highlight!: boolean;
  @Prop({ type: Boolean, default: false }) readonly dark!: boolean;

  @Ref() readonly returnFocusTargetRef?: HTMLButtonElement;

  async mounted() {
    await this.$nextTick();
    this.returnFocusTarget = this.returnFocusTargetRef || null;
  }
}
